import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import { DEFAULT_SEO_CONFIG, ROOT_URL_PRODUCTION } from '../../next-seo.config';
import { LimitOrders } from '../components/LimitOrders';
import { routes } from '../utils/routes';

const LIMIT_ORDERS_TITLE = ' Limit orders for crypto trading';
const LIMIT_ORDERS_DESCRIPTION =
  'Place limit orders with no gas fee. Set the price you want when you sell or buy crypto with decentralized limit orders on Matcha DEX aggregator.';

const LimitOrdersPage: NextPage = () => {
  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={LIMIT_ORDERS_TITLE}
        description={LIMIT_ORDERS_DESCRIPTION}
        canonical={`${ROOT_URL_PRODUCTION}${routes.LIMIT_ORDERS}`}
        openGraph={{
          images: [
            {
              url: `${ROOT_URL_PRODUCTION}/images/og/social-limit-orders-banner.jpg`,
              width: 1200,
              height: 630,
              alt: 'Matcha',
            },
          ],
        }}
        additionalMetaTags={[
          {
            name: 'twitter:title',
            content: LIMIT_ORDERS_TITLE,
          },
          {
            name: 'twitter:description',
            content: LIMIT_ORDERS_DESCRIPTION,
          },
          {
            name: 'twitter:image',
            content: `${ROOT_URL_PRODUCTION}/images/og/social-limit-orders-banner.jpg`,
          },
          {
            name: 'twitter:url',
            content: `${ROOT_URL_PRODUCTION}${routes.LIMIT_ORDERS}`,
          },
        ]}
      />
      <LimitOrders />
    </>
  );
};

export default LimitOrdersPage;
